import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { dataProfesores } from "data/apiConection.js/dataProfesores";
import { addUser } from "data/apiConection.js/dataUsers"; // Actualiza con la ruta correcta

const FormUser = ({ setFlagAddUser, flagAddUser }) => {
  const [profesores, setProfesores] = useState([]);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    profesor_id: "",
    role: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleRoleChange = (role) => {
    setFormData((prevData) => ({
      ...prevData,
      role: prevData.role === role ? "" : role, // Alternar selección
      profesor_id: role !== "teacher" ? "" : prevData.profesor_id, // Limpiar profesor si no es teacher
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false || !formData.role) {
      event.preventDefault();
      event.stopPropagation();
    } else if (formData.role === "teacher" && !formData.profesor_id) {
      event.preventDefault();
      alert("Por favor, seleccione un profesor para el rol de Teacher.");
      return;
    } else {
      event.preventDefault();
      const body = {
        ...formData,
        profesor_id: formData.role === "teacher" ? formData.profesor_id : null,
      };
      console.log(body);
      const response = await addUser(body);
      if (response.message === "User created successfully!") {
        setFlagAddUser(!flagAddUser);
      }
    }
    setValidated(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pr = await dataProfesores();
        setProfesores(pr);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro de Usuario</Card.Title>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="username">
              <Form.Label>Nombre de Usuario</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nombre de Usuario"
                value={formData.username}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un nombre de usuario.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="password">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Contraseña"
                value={formData.password}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese una contraseña.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Correo Electrónico"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un correo electrónico válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Roles</Form.Label>
              <Row>
                <Col md="4">
                  <Form.Check
                    type="checkbox"
                    id="manager"
                    label="Manager"
                    checked={formData.role === "manager"}
                    onChange={() => handleRoleChange("manager")}
                  />
                </Col>
                <Col md="4">
                  <Form.Check
                    type="checkbox"
                    id="admin"
                    label="Admin"
                    checked={formData.role === "admin"}
                    onChange={() => handleRoleChange("admin")}
                  />
                </Col>
                <Col md="4">
                  <Form.Check
                    type="checkbox"
                    id="teacher"
                    label="Teacher"
                    checked={formData.role === "teacher"}
                    onChange={() => handleRoleChange("teacher")}
                  />
                </Col>
              </Row>
              {!formData.role && (
                <div className="text-danger mt-2">
                  Por favor, seleccione un rol.
                </div>
              )}
            </Form.Group>
          </Row>
          {formData.role === "teacher" && (
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="profesor_id">
                <Form.Label>Profesor</Form.Label>
                <Form.Select
                  required
                  value={formData.profesor_id}
                  onChange={handleInputChange}
                >
                  <option value="">Seleccione un profesor</option>
                  {profesores.map((profesor) => (
                    <option key={profesor.id} value={profesor.id}>
                      {profesor.firstName} {profesor.lastName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Por favor, seleccione un profesor.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          )}
          <div className="d-grid gap-2 mt-4">
            <Button type="submit" size="lg">
              Enviar Usuario
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

FormUser.propTypes = {
  setFlagAddUser: PropTypes.func,
  flagAddUser: PropTypes.bool,
};

export default FormUser;
